import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Close from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  root: {
    height: '100%',
    color: theme.palette.white,
    backgroundColor: theme.palette.error.main,
  },
  wrapper: {
    ...theme.components.toast,
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  open: {
    opacity: 1,
  },
  content: {
    display: 'flex',
    alignItems: 'center',
  },
  closeButton: {
    display: 'flex',
    cursor: 'pointer',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all .3s ease',
    color: theme.palette.white,
    '& path': {
      fill: theme.palette.white,
    },
    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
  text: {
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(2),
  },
})

const ErrorToast = ({
  classes, data, open, handleClose
}) => (
  <div className={classes.root}>
    <section className={classNames(classes.wrapper, open && classes.open)}>
      <div className={classes.content}>
        <Typography className={classes.text}>{data.message || data}</Typography>
      </div>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <Close />
      </IconButton>
    </section>
  </div>
)

ErrorToast.propTypes = {
  data: PropTypes.any,
  open: PropTypes.bool,
  classes: PropTypes.object,
  handleClose: PropTypes.func,
}

export default withStyles(styles)(ErrorToast)



// WEBPACK FOOTER //
// ./src/components/atoms/toasts/ErrorToast.js